module.exports = __webpack_public_path__ + "static/media/secondVideo.e61d84cd.mp4";